import { combineReducers } from "@reduxjs/toolkit";
import { RootState } from "..";
import casesTableStore from './casesTableStore'
import casesBonusStore from './Bonus/casesBonus'
import casesProfileStore from "./Profile/casesProfile";
import { apiUrlV1 } from "../../config/config";
import casesEntityStore from './Entity/casesEntity'

// export domain links
export const casesUrl = apiUrlV1 + "/v2/organization/game/case";

// export selectors
export const selectCasesTable = (state: RootState) => state.cases.tables;

export const selectCasesBonus = (state: RootState) => state.cases.bonus;

export const selectCasesProfile = (state: RootState) => state.cases.profile;

export const selectCasesEntity = (state: RootState) => state.cases.entity;

export const casesReducer = combineReducers({
  tables: casesTableStore,
  bonus: casesBonusStore,
  profile: casesProfileStore,
  entity: casesEntityStore,
});
